import {fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const tip = (
    venueId,
    dancerId,
    tipAmount,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    const params = {
        venueId: venueId,
        dancerId: dancerId,
        tipAmount: tipAmount
    };
    fetchPost(
        uri + "/user/tip",
        successMethod,
        errorMethod,
        params,
        getAccessToken);
};